import request from '@/utils/request'

// 前置校验
export function user_check_aes(data) {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/pwd_back/user_check',
    method: 'post',
    data
  })
}
// 找回密码
export function phone_pwd_back_aes(data) {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/pwd_back/find',
    method: 'post',
    data
  })
}
// 查询角色列表
export function getAllRole() {
  return process.env.VUE_APP_BASE_API_HELPER + '/self/appealNew/getAllRole.do'
}

// 发送短信
export function send_phone_message_new() {
  return process.env.VUE_APP_BASE_API_HELPER + '/message/send_phone_message_new.do'
}

// 验证手机
export function verify_phone_message_new() {
  return process.env.VUE_APP_BASE_API_HELPER + '/message/verify_phone_message_new.do'
}

// 验证手机
export function checkSendPhone(data) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/self/appealNew/checkSendPhone.do',
    method: 'post',
    data
  })
}

// 登录成功后回调请求
export function loginCallback() {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/self/appealNew/login/callback.do',
    method: 'post'
  })
}
